module.exports = __webpack_public_path__ + "img/ico-acompañamos.a8ef618f.svg";